import {
  ENDPOINT_FORMAT,
  ENDPOINT_ORDER,
  ENDPOINT_ROOT,
  PDF_FILE,
} from '@/common/constants';
import downloadFileFromBytes from '@/common/helpers/downloadFileFromBytes';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const getDeliveryNote = ({
  queryKey: [endpoint, deliveryNoteId, orderId, formatId],
}) =>
  axiosAuth
    .get(
      `${ENDPOINT_ROOT}/${endpoint}/${deliveryNoteId}/${ENDPOINT_ORDER}/${orderId}/${ENDPOINT_FORMAT}/${formatId}/${PDF_FILE}`,
      { responseType: 'blob' },
    )
    .then((res) => {
      downloadFileFromBytes(res.data, `${deliveryNoteId}.${PDF_FILE}`);
    });

export default getDeliveryNote;
